import { http } from "../client";
export var publishTracks = function (_a) {
    var tracksIds = _a.tracksIds;
    var payload = {
        tracks: tracksIds.map(function (id) { return ({ id: id, is_approved: true }); }),
    };
    return http.api.put("tracks", payload);
};
export var unpublishTracks = function (_a) {
    var tracksIds = _a.tracksIds;
    var payload = {
        tracks: tracksIds.map(function (id) { return ({ id: id, is_approved: false }); }),
    };
    return http.api.put("tracks", payload);
};
